import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LabelPill from './pill/LabelPill';

// What kind of workflow this is — a classification, not a state, so these are neutral label
// pills. They always sit beside the workflow's name, hence the inline size, and they no longer
// carry the border that used to make them the only outlined badge in the app.
const TYPE_CONFIG = {
  user: {
    label: 'User',
    title: 'User workflow: anonymous public flow. Tasks appear in the Feedback tab.',
  },
  self_startable: {
    label: 'Self-startable',
    title: 'Field engineers can start this workflow without an assigned task.',
  },
};

function WorkflowTypeBadge({ type, className }) {
  const config = TYPE_CONFIG[type];
  if (!config) return null;

  return (
    <LabelPill size="inline" title={config.title} className={className}>
      {config.label}
    </LabelPill>
  );
}

export function WorkflowTypeBadges({ workflow, className }) {
  if (!workflow) return null;

  const hasBadge = workflow.user_workflow || workflow.self_startable;
  if (!hasBadge) return null;

  return (
    <span className={classNames('d-inline-flex align-items-center gap-1', className)}>
      {workflow.user_workflow && <WorkflowTypeBadge type="user" />}
      {workflow.self_startable && <WorkflowTypeBadge type="self_startable" />}
    </span>
  );
}

WorkflowTypeBadge.propTypes = {
  type: PropTypes.oneOf(['user', 'self_startable']).isRequired,
  className: PropTypes.string,
};

WorkflowTypeBadge.defaultProps = {
  className: '',
};

WorkflowTypeBadges.propTypes = {
  workflow: PropTypes.shape({
    user_workflow: PropTypes.bool,
    self_startable: PropTypes.bool,
  }),
  className: PropTypes.string,
};

WorkflowTypeBadges.defaultProps = {
  workflow: null,
  className: '',
};
